import { BottomSheet } from "@/components/modals/BottomSheet";
import { Category } from "@/types";
import { Icon, ListRow, SheetBody } from "@/components/ui";
import { Check } from "@/icons";

type CategoryPickerModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  categories: Category[];
  activeCategoryId: string;
  onSelect: (categoryId: string) => void;
};

export function CategoryPickerModal({
  open,
  onOpenChange,
  categories,
  activeCategoryId,
  onSelect,
}: CategoryPickerModalProps) {
  function handleSelect(categoryId: string) {
    onSelect(categoryId);
    onOpenChange(false);
  }

  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} title="Categorias" onClose={() => onOpenChange(false)}>
      <SheetBody maxHeight="md" gutter="flush" className="pb-safe">
        <ul className="flex flex-col divide-y divide-card-text/10">
          {categories.map((category) => {
            const isActive = category.id === activeCategoryId;
            return (
              <li key={category.id}>
                <ListRow
                  as="button"
                  variant="plain"
                  size="lg"
                  inset
                  titleWeight={isActive ? "bold" : "medium"}
                  aria-current={isActive ? "true" : undefined}
                  onClick={() => handleSelect(category.id)}
                  title={category.name}
                  tone={isActive ? "primary" : "muted"}
                  trailing={isActive ? <Icon as={Check} size="lg" weight="bold" tone="primary" /> : undefined}
                />
              </li>
            );
          })}
        </ul>
      </SheetBody>
    </BottomSheet>
  );
}
